<template>
  <base-dialog width="553px" :dialogVisible="dialogVisible" @handleConfirm="handleConfirm"
               @handleClose="handleClose">
    <template #title>{{title}}</template>
    <div class="score-body">
      <!-- 系统评分暂时隐藏 -->
      <template v-if="false">
        <div class="top">
          <!-- 左侧线形进度条 -->
          <div class="left">
            <ul>
              <li v-for="item in lineList" :key="item.str">
                <span class="label">{{item.title}}：</span>
                <el-progress :stroke-width="8" :color="item.color" :percentage="item.percentage">
                </el-progress>
              </li>
            </ul>
          </div>
          <!-- 右侧环形进度条 -->
          <div class="right">
            <el-progress class="right-progress" type="circle" :show-text="false" :stroke-width='14'
                         :percentage="circleList.systemPercentage">
            </el-progress>
            <div class="text">
              <div class="score-text">{{circleList.systemPercentage}}</div>
              <div class="person">系统评分</div>
            </div>
            <!-- 进度条svg修改 -->
            <svg-linear-gradient style="width: 0;height: 0;opacity:0;"></svg-linear-gradient>
          </div>
        </div>
      </template>
      <!-- 底部老师评价 -->
      <div class="bottom">
        <!-- 评分 -->
        <div class="branch">
          <span class="label">评分：</span>
          <el-slider ref="slider" v-model="teacherEvaluation.manualScore" :marks="marks"
                     :show-tooltip="false" show-input>
          </el-slider>
          分
        </div>
        <!-- 评价 -->
        <div class="evaluate">
          <span class="label">评价：</span>
          <el-input type="textarea" placeholder="最多支持200字..." maxlength="200"
                    v-model="teacherEvaluation.eval" resize="none">
          </el-input>
        </div>
      </div>
    </div>
    <template #close>返回</template>
    <template #confirm>确认</template>
  </base-dialog>
</template>

<script>
import BaseDialog from '@/common/base-dialog';
import svgLinearGradient from '@/components/svg-linear-gradient';
import { insertTaskManualScore } from '@/services/editorApi';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'scoreDialog',
  components: {
    BaseDialog,
    svgLinearGradient
  },
  props: {
    // 控制弹窗开关
    dialogVisible: {
      type: Boolean,
      default: false
    },
    // 弹窗标题
    title: {
      type: String,
      default: '提示'
    },
    // 修改评价 (true)/评价评分(false)
    isEditor: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    // 监听弹窗开启
    dialogVisible (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.getEvaluationResults()
          this.sliderTransition()
        })
      }
    }
  },
  data () {
    return {
      lineList: [
        { title: '准确度', color: '#4F72F5', percentage: 0, str: 'accuracy' },
        { title: '忠实度', color: '#1CDBC7', percentage: 0, str: 'faithful' },
        { title: '流畅度', color: '#FFC115', percentage: 0, str: 'fluent' },
        { title: '完整度', color: '#FF3BB7', percentage: 0, str: 'complete' },
      ],
      circleList: {
        systemPercentage: 0
      },
      // 评分及评语
      teacherEvaluation: {
        manualScore: 0,
        eval: "",
      },
      // 老师评价 刻度显示
      marks: {
        0: '0',
        50: '50',
        100: '100'
      },
    }
  },
  computed: {
    ...mapGetters('editor', [
      'getUrlInfo',          // 路由参数
      'evaluationResults',   // 评价数据
    ]),
  },
  methods: {
    ...mapActions('editor', [
      'updateEvaluationResults',  // 更新/获取 评价
    ]),
    /**
     * @desc 获取/更新评价
     */
    getEvaluationResults () {
      this.lineList.forEach(item => {
        if (this.evaluationResults.hasOwnProperty(item.str)) {
          item.percentage = this.evaluationResults[item.str]
        }
      })
      const { avgScore } = this.evaluationResults
      this.circleList.systemPercentage = avgScore
      // 如果是老师、校领导 一开始会在editorOperation组件调用获取评价接口 将结果存储
      // 修改评价功能 回显 
      if (!this.isEditor) {
        return
      }
      if (this.evaluationResults.manualScore) {
        this.teacherEvaluation.manualScore = this.evaluationResults.manualScore
      }
      if (this.evaluationResults.eval) {
        this.teacherEvaluation.eval = this.evaluationResults.eval
      }
    },
    /**
     * @desc 滑块过渡效果
     */
    sliderTransition () {
      const domNodes = this.$refs.slider.$el.querySelector('.el-slider__runway ').children
      domNodes[0].style.transition = 'width 0.6s ease'
      domNodes[1].style.transition = 'left 0.6s ease'
      let timer = window.setTimeout(() => {
        clearTimeout(timer)
        timer = null
        domNodes[0].style.transition = 'none'
        domNodes[1].style.transition = 'none'
      }, 620)
    },
    /**
     * @desc 重置操作
     */
    clear () {
      window.setTimeout(() => {
        this.teacherEvaluation = {
          manualScore: 0,
          eval: "",
        }
        // 每次关闭弹窗进度条进度重置为0,即可在打开时保留过渡效果
        this.circleList.systemPercentage = 0
        this.lineList.forEach(item => { item.percentage = 0 })
      }, 200)
    },
    /**
     * @desc 返回按钮的方法
     */
    handleClose () {
      this.$emit('handleClose');
      this.clear()
    },
    /**
     * @desc 确认按钮的方法
     */
    async handleConfirm () {
      const { taskId } = this.getUrlInfo
      const params = {
        taskId,
        ...this.teacherEvaluation
      }
      // 调用批改作业接口
      const { success } = await insertTaskManualScore(params)
      if (!success) {
        return
      }
      // 更新评价 evaluationResults
      this.$emit('handleConfirm');
      this.clear()
      this.updateEvaluationResults({ taskId })
    }
  }
}
</script>

<style lang="less" scoped>
@import "./assets/index.less";
</style>